import { createSelector } from 'reselect';
import { compareCaseInsensitive } from 'app/utils/strings';
import { isFeenyEnabled } from 'app/api/redux-watson/watson-config-selectors';

const emptyArray = [];

function getAssignments(state) {
  const base = state.feeny.assignments.data;
  return base && base.data ? base.data : emptyArray;
}

function createSelectorFactory() {
  const selectors = {};

  return function(state, vbid) {
    if (!selectors[vbid]) {
      selectors[vbid] = createSelector(
        state => getAssignments(state),
        assignments =>
          assignments
            .filter(a => a.vbid === vbid)
            .sort((a, b) => compareCaseInsensitive(a.title, b.title))
      );
    }

    return selectors[vbid](state);
  };
}

export const getAssignmentsForVbid = createSelectorFactory();

export function needsAssignmentFetch(state) {
  const base = state.feeny.assignments;
  return (
    isFeenyEnabled(state) &&
    !base.isFetching &&
    (!base.successQuery && !base.failQuery)
  );
}



// WEBPACK FOOTER //
// ./src/app/api/redux-feeny/assignments/selectors.js